export * from "./permission.interface";
